import Services from '../components/Services';
import Philosophy from '../components/Philosophy';

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-900 to-primary-900">
      <Services />
      <Philosophy />
    </div>
  );
};

export default ServicesPage;
